import { TRANSFORMERS, Transformer } from '@lexical/markdown';
import { LexicalEditor } from 'lexical';
import { createHtmlTransformer } from './html';
import { BR } from './html/br';
import { createTableTransformer as createHtmlTableTransformer } from './html/table';
import { IMAGE } from './image';
import { INLINE_SUGGESTION } from './inline-suggestions';
import { createSuggestionTransformer } from './suggestion';
import { createTableTransformer as createMarkdownTableTransformer } from './table';

export const createTransformers = (editor: LexicalEditor): Transformer[] => {
  const baseTransformers = [...TRANSFORMERS, INLINE_SUGGESTION, BR, IMAGE];
  const markdownTableTransformer = createMarkdownTableTransformer(baseTransformers);
  const suggestionTransformer = createSuggestionTransformer(baseTransformers);
  const htmlTransformer = createHtmlTransformer(editor);
  const htmlTableTransformer = createHtmlTableTransformer(editor);

  return [
    suggestionTransformer,
    htmlTransformer,
    htmlTableTransformer,
    markdownTableTransformer,
    ...baseTransformers,
  ];
};
